import {
  PIPEFITTER_PROJECT_LOADER_START,
  PIPEFITTER_PROJECT_LOADER_STOP,
  PIPEFITTER_SET_PROJECT_LIST,
  PIPEFITTER_SET_SELECTED_PROJECT,
  PIPEFITTER_SET_PIPE_COUNT,
  PIPEFITTER_SET_TOTAL_PIPE_COUNT,
  PIPEFITTER_SET_USED_PIPE_COUNT,
  PIPEFITTER_SET_SPREAD_PIPE_COUNT,
  PIPEFITTER_SET_SUBSPREAD_PIPE_COUNT,
  PIPEFITTER_SET_MEAN_MAX_CALCULATION_STATUS,
} from './types';

const initialState = {
  isProjectLoading: false,
  projectList: [],
  selectedProject: {},
  projectPipeCount: 0,
  totalPipeCount: 0,
  usedPipeCount: 0,
  spreadPipeCount: 0,
  subSpreadPipeCount: 0,
  /** Cached once per projectNumber after pipe sizes load — used by Generate Report gate. */
  meanMaxCalculationStatus: null,
  meanMaxStatusProjectNumber: null,
  meanMaxStatusError: null,
};

export default function pipefitterProjectReducer(state = initialState, action) {
  switch (action.type) {
    case PIPEFITTER_PROJECT_LOADER_START:
      return { ...state, isProjectLoading: true };
    case PIPEFITTER_PROJECT_LOADER_STOP:
      return { ...state, isProjectLoading: false };
    case PIPEFITTER_SET_PIPE_COUNT:
      return { ...state, projectPipeCount: action.payload };
    case PIPEFITTER_SET_TOTAL_PIPE_COUNT:
      return { ...state, totalPipeCount: action.payload };
    case PIPEFITTER_SET_USED_PIPE_COUNT:
      return { ...state, usedPipeCount: action.payload };
    case PIPEFITTER_SET_SPREAD_PIPE_COUNT:
      return { ...state, spreadPipeCount: action.payload };
    case PIPEFITTER_SET_SUBSPREAD_PIPE_COUNT:
      return { ...state, subSpreadPipeCount: action.payload };
    case PIPEFITTER_SET_PROJECT_LIST:
      return { ...state, projectList: action.payload };
    case PIPEFITTER_SET_SELECTED_PROJECT:
      return { ...state, selectedProject: action.payload };
    case PIPEFITTER_SET_MEAN_MAX_CALCULATION_STATUS: {
      const {
        projectNumber = null,
        status = null,
        error = null,
      } = action.payload || {};
      return {
        ...state,
        meanMaxCalculationStatus: status,
        meanMaxStatusProjectNumber: projectNumber,
        meanMaxStatusError: error,
      };
    }
    default:
      return state;
  }
}
